import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';

const WelcomeMessage = ({ onQuestionClick }) => {
  const sampleQuestions = [
    { text: '승률이 가장 높은 트레이더는?', icon: 'fa-trophy' },
    { text: '샤프 비율 상위 3명은?', icon: 'fa-medal' },
    { text: '총 수익이 가장 많은 사람은?', icon: 'fa-dollar-sign' },
    { text: '아침에 주로 거래하는 트레이더는?', icon: 'fa-clock' }
  ];

  return (
    <div className="text-center mt-5">
      <i className="fas fa-robot fa-4x text-primary mb-3"></i>
      <h4 className="mb-3">트레이더 분석 AI 챗봇</h4>
      <p className="text-muted mb-4">50명의 트레이더 성과를 실시간으로 분석합니다</p>
      
      <h6 className="mb-3">
        <i className="fas fa-lightbulb me-2"></i>
        추천 질문
      </h6>
      <Row className="g-2 justify-content-center">
        {sampleQuestions.map((q, idx) => (
          <Col key={idx} xs={12} md={6}>
            <Button 
              variant="outline-primary" 
              size="sm" 
              className="w-100"
              onClick={() => onQuestionClick(q.text)}
            >
              <i className={`fas ${q.icon} me-2`}></i>
              {q.text}
            </Button>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default WelcomeMessage;
